import React, { FC, memo } from 'react';

import { formatDate, parseDate, today } from './utils';

import {
  Container,
  DayPickerInput,
  DayPickerStyles,
  CalendarIcon,
} from './styles';
import { Props } from './types';

import 'react-day-picker/lib/style.css';

const DateRangePicker: FC<Props> = ({
  dateHandleChange,
  date,
  dateLimit,
  ...props
}) => {
  const modifiers = { start: date, end: date };

  return (
    <Container {...props}>
      <DayPickerStyles>
        <CalendarIcon />
        <DayPickerInput
          {...props}
          value={date}
          formatDate={formatDate}
          placeholder=""
          parseDate={parseDate}
          onDayChange={dateHandleChange}
          dayPickerProps={{
            selectedDays: [date],
            // disabledDays: [{ after: to }, { after: yesterday }],
            // toMonth: to,
            disabledDays: [
              { before: today },
              ...(dateLimit ? [{ before: dateLimit }] : []),
            ],
            // toMonth: yesterday,
            modifiers,
            numberOfMonths: 2,
          }}
        />
      </DayPickerStyles>
    </Container>
  );
};

export default memo(DateRangePicker);
